import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import axios from 'axios'
import {toast} from 'react-toastify'
import {stopLoading} from '../FrontEnd/Loading/LoadingSlice'
import {ENV} from '../../Utils/_helpers/EnvHelper'

const API_URL = ENV().REACT_APP_API_URL
const initialState: any = {
  productList: [],
  cardList: [],
}

export const GetProductList: any = createAsyncThunk(
  '/GetProductList',
  async (data: any, thunkApi) => {
    const response: any = await axios.get(`${API_URL}user/gatewayplans`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    // .catch((err) => {
    //   toast.error(err?.response?.data?.error?.email)
    // })

    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const GetCardList: any = createAsyncThunk('/GetCardList', async (data: any, thunkApi) => {
  const response: any = await axios.get(`${API_URL}user/getCards`, {
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
  })
  // .catch((err) => {
  //   toast.error(err?.response?.data?.error?.email)
  // })

  thunkApi.dispatch(stopLoading())
  return response.data
})
export const ApplyCouponCode: any = createAsyncThunk(
  '/ApplyCouponCode',
  async (data: any, thunkApi) => {
    const response: any = await axios.post(`${API_URL}user/verifycoupon`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })

    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

const ProductList = createSlice({
  name: 'ProductList',
  initialState,
  reducers: {},
  extraReducers: {
    ////////////////////////////superadmin------------Payment Gateway///////////////////////////////////////////////////////////////////
    [GetProductList.fulfilled]: (state, {payload}) => {
      return {...state, productList: payload.data}
    },
    [GetCardList.fulfilled]: (state, {payload}) => {
      return {...state, cardList: payload.data}
    },
  },
})

export default ProductList.reducer
